export default "__VITE_ASSET__Dolwh$VI__"